export default __webpack_public_path__ + "static/media/img1.f984b3e8.png";